// Import the functions you need from the SDKs you need
import * as firebase from 'firebase/app'
import { getMessaging, isSupported } from 'firebase/messaging'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export const initialize = (
  FIREBASE_KEY,
  AUTH_DOMAIN,
  PROJECT_ID,
  STORAGE_BUCKET,
  MSG_SENDER_ID,
  APP_ID,
  MEASUREMENT_ID
) => {
  const firebaseConfig = {
    apiKey: "AIzaSyBPQdRN2QAfFqub5xuXH2olIx9jYJzZ9_c",
    authDomain: "arrivalxo.firebaseapp.com",
    projectId: "arrivalxo",
    storageBucket: "arrivalxo.firebasestorage.app",
    messagingSenderId: "122730829359",
    appId: "1:122730829359:web:a2a289b4c2fb2ee81798da",
    measurementId: "G-XREFB9XN9D"
  }

  // Initialize Firebase
  const app = firebase.initializeApp(firebaseConfig)
  const messaging = getMessaging(app)
  return messaging
}
export const isFirebaseSupported = async() => {
  return await isSupported()
}
